
import { defineComponent } from 'vue';
import { AppFormRow, AppInput, AppCard, AppButton, AppFileUpload, AppSwitch } from '@/components';
import { useAvatarBackgroundAdd } from '@/modules/avatar/background/model/add';
import { ROUTE_NAME_AVATAR } from '@/modules/avatar/router';

export default defineComponent({
    name: ROUTE_NAME_AVATAR.BACKGROUND.ADD,
    components: { AppFormRow, AppInput, AppCard, AppButton, AppFileUpload, AppSwitch },
    setup() {
        const { model, v$, create } = useAvatarBackgroundAdd();

        return { v$, model, create };
    }
});
